;
define("quick_order_empty_cart.tpl", function(){});

